const menuItems = [
  {
    header: "About us",
    list: [
      { key: "l11", label: "About Us", href: "/about-us" },
      { key: "l12", label: "Welldoing charter", href: "/welldoing-charter" },
      { key: "l13", label: "Find a therapist", href: "/find-a-therapist" },
      { key: "l14", label: "Our therapists", href: "/counselling" },
      { key: "l15", label: "For individuals", href: "/user-benefits" },
      { key: "l15", label: "For organisations", href: "/workplace-wellness" },
      {
        key: "l15",
        label: "For practitioners",
        href: "practitioners/therapist-info",
      },
    ],
  },
  {
    header: "Our content",
    list: [
      { key: "l21", label: "Read articles", href: "/article" },
      {
        key: "l26",
        label: "CPD and Event Hub",
        href: "/free-online-cpd-welldoing-members",
      },
      { key: "l22", label: "Help centre", href: "/help-centre" },
      { key: "l23", label: "Press", href: "/press" },
      { key: "l24", label: "Testimonials", href: "/testimonials" },
      {
        key: "l25",
        label: "Welldoing Inspiration Awards",
        href: "/welldoing-inspiration-awards",
      },
    ],
  },
  {
    header: "Contact us",
    list: [
      { key: "l51", label: "Health Foundry", href: "#" },
      { key: "l52", label: "Canterbury House", href: "#" },
      { key: "l53", label: "1 Royal Street", href: "#" },
      { key: "l54", label: "London", href: "#" },
      { key: "l55", label: "SE1 7LL", href: "#" },
      {
        key: "l56",
        label: "info@welldoing.org",
        href: "mailto:info@welldoing.org",
      },
    ],
  },
];

export default menuItems;
